
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Navimumbaitokolhapurcab() {



const cardData = {
  keyword: "Navi Mumbai to Kolhapur Cab",
  heading: "Skyline Cabs: Navi Mumbai to Kolhapur Cab",
  headingDescription: "Skyline Cabs offers premium and affordable Navi Mumbai to Kolhapur Cab services designed for comfortable long-distance travel across Maharashtra. Whether you are planning a spiritual visit to Mahalaxmi Temple, a family vacation, a business trip, or a weekend getaway, we provide safe highway travel with experienced drivers and well-maintained AC vehicles. From Mumbai to Kolhapur cab to Navi Mumbai to Kolhapur taxi options, our services include one way, round trip, and customized outstation packages. With transparent pricing, professional chauffeurs, and secure online cab booking Navi Mumbai to Kolhapur, Skyline Cabs ensures smooth travel covering expressways and national highways with complete comfort and punctuality.",

  top: "Top Places to Visit in Kolhapur with Skyline Cabs",

  topPlaces: [
    {
      title: "Mahalaxmi Temple",
      description: "Mahalaxmi Temple is one of the most sacred pilgrimage sites in Maharashtra attracting devotees throughout the year. Dedicated to Goddess Mahalaxmi, this ancient temple reflects traditional Hemadpanthi architecture. Visitors experience spiritual peace and divine blessings. Skyline Cabs ensures comfortable Navi Mumbai to Kolhapur cab travel for temple visits with punctual drop and pickup."
    },
    {
      title: "Rankala Lake",
      description: "Rankala Lake is a beautiful recreational spot offering sunset views and peaceful walking areas. It is ideal for families and couples seeking relaxation. The lakeside atmosphere adds charm to Kolhapur tourism."
    },
    {
      title: "Panhala Fort",
      description: "Panhala Fort is a historic Maratha fort offering panoramic valley views and rich heritage significance. It attracts history enthusiasts and trekkers."
    },
    {
      title: "Jyotiba Temple",
      description: "Jyotiba Temple located on a hilltop is another major pilgrimage attraction near Kolhapur."
    },
    {
      title: "New Palace Museum",
      description: "New Palace Museum displays royal artifacts of Kolhapur rulers and reflects architectural beauty."
    },
    {
      title: "Radhanagari Wildlife Sanctuary",
      description: "Radhanagari Wildlife Sanctuary is perfect for nature lovers and wildlife enthusiasts."
    },
    {
      title: "Town Hall Museum",
      description: "Town Hall Museum showcases historical sculptures and ancient artifacts."
    },
    {
      title: "Bhavani Mandap",
      description: "Bhavani Mandap is a historic palace complex reflecting Kolhapur’s royal heritage."
    },
    {
      title: "Dajipur Wildlife Sanctuary",
      description: "Dajipur Wildlife Sanctuary is known for lush greenery and diverse wildlife."
    },
    {
      title: "Kopeshwar Temple",
      description: "Kopeshwar Temple is an ancient Shiva temple famous for its unique architectural design."
    }
  ],

  services: [
    {
      name: "mumbai to kolhapur cab",
      description: "Skyline Cabs provides reliable mumbai to kolhapur cab service with comfortable AC vehicles and professional long-distance drivers. Whether you are traveling for pilgrimage, family visits, or corporate work, our mumbai to kolhapur cab ensures smooth highway travel with transparent pricing and timely pickup. We cover expressway and national highway routes efficiently, offering stress-free journey planning and safe overnight travel options."
    },
    {
      name: "mumbai airport to kolhapur cab",
      description: "Our mumbai airport to kolhapur cab service offers direct airport pickup and comfortable transfer to Kolhapur without delays. We monitor flight schedules to ensure punctual arrival and smooth departure coordination. Ideal for business travelers and family groups, this service includes spacious luggage handling and experienced chauffeurs trained for long-distance driving."
    },
    {
      name: "mumbai kolhapur cab service",
      description: "The mumbai kolhapur cab service by Skyline Cabs includes one way and round trip packages with competitive pricing. Customers enjoy clean vehicles, verified drivers, and transparent billing. Our service ensures convenient travel for temple visits, tourism, and corporate assignments."
    },
    {
      name: "mumbai to kolhapur car rental",
      description: "Choose mumbai to kolhapur car rental options including sedan, SUV, and Innova vehicles for flexible scheduling. Our rental packages allow customized stopovers and comfortable travel suited for families and business executives."
    },
    {
      name: "navi mumbai to kolhapur cab",
      description: "Premium navi mumbai to kolhapur cab services with smooth pickup from residential and commercial areas. We guarantee safe travel experience with highway expertise and comfortable seating arrangements."
    },
    {
      name: "navi mumbai to kolhapur taxi",
      description: "Affordable navi mumbai to kolhapur taxi service offering well-maintained vehicles and professional drivers ensuring safe and punctual arrival."
    },
    {
      name: "navi mumbai to kolhapur cab service",
      description: "Reliable navi mumbai to kolhapur cab service designed for spiritual tours, family trips, and corporate travel with flexible scheduling."
    },
    {
      name: "taxi from navi mumbai to kolhapur",
      description: "Book taxi from navi mumbai to kolhapur for direct, safe, and uninterrupted long-distance travel."
    },
    {
      name: "cab from navi mumbai to kolhapur",
      description: "Comfortable cab from navi mumbai to kolhapur with AC vehicles and transparent billing."
    },
    {
      name: "book cab navi mumbai to kolhapur",
      description: "Easily book cab navi mumbai to kolhapur using our secure online booking platform."
    },
    {
      name: "online cab booking navi mumbai to kolhapur",
      description: "Instant online cab booking navi mumbai to kolhapur with real-time confirmation."
    },
    {
      name: "best cab navi mumbai to kolhapur",
      description: "Recognized as best cab navi mumbai to kolhapur service for safety and reliability."
    },
    {
      name: "cheapest cab navi mumbai to kolhapur",
      description: "Affordable cheapest cab navi mumbai to kolhapur packages without hidden charges."
    },
    {
      name: "Reliable taxi navi mumbai to kolhapur",
      description: "Trusted Reliable taxi navi mumbai to kolhapur ensuring smooth and safe highway journey."
    },
    {
      name: "one way cab navi mumbai to kolhapur",
      description: "Flexible one way cab navi mumbai to kolhapur for direct travel plans."
    },
    {
      name: "round trip cab navi mumbai to kolhapur",
      description: "Convenient round trip cab navi mumbai to kolhapur with return scheduling options."
    },
    {
      name: "outstation cab navi mumbai to kolhapur",
      description: "Premium outstation cab navi mumbai to kolhapur ideal for weekend and holiday travel."
    },
    {
      name: "innova cab navi mumbai to kolhapur",
      description: "Spacious innova cab navi mumbai to kolhapur suitable for family and group travel."
    }
  ],

  tableData: [
    ["mumbai to kolhapur cab", "mumbai airport to kolhapur cab"],
    ["mumbai kolhapur cab service", "mumbai to kolhapur car rental"],
    ["navi mumbai to kolhapur cab", "navi mumbai to kolhapur taxi"],
    ["navi mumbai to kolhapur cab service", "taxi from navi mumbai to kolhapur"],
    ["cab from navi mumbai to kolhapur", "book cab navi mumbai to kolhapur"],
    ["online cab booking navi mumbai to kolhapur", "best cab navi mumbai to kolhapur"],
    ["cheapest cab navi mumbai to kolhapur", "Reliable taxi navi mumbai to kolhapur"],
    ["one way cab navi mumbai to kolhapur", "round trip cab navi mumbai to kolhapur"],
    ["outstation cab navi mumbai to kolhapur", "innova cab navi mumbai to kolhapur"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Experienced Highway Drivers",
      WhyChoosedescription: "Our drivers are trained for long-distance highway travel ensuring safe navigation across expressways and ghat sections between Navi Mumbai and Kolhapur. We prioritize passenger safety, smooth driving, and timely arrival for every booking."
    },
    {
      WhyChooseheading: "Transparent Pricing Structure",
      WhyChoosedescription: "We provide clear fare details without hidden charges for all Navi Mumbai to Kolhapur cab services ensuring budget-friendly and trustworthy booking experience."
    },
    {
      WhyChooseheading: "24x7 Availability",
      WhyChoosedescription: "Round-the-clock cab services including early morning and late-night departures with secure confirmation."
    },
    {
      WhyChooseheading: "Multiple Vehicle Options",
      WhyChoosedescription: "Choose from sedan, SUV, and Innova vehicles depending on group size and comfort needs."
    },
    {
      WhyChooseheading: "Safe & Sanitized Fleet",
      WhyChoosedescription: "All vehicles are regularly cleaned and maintained for hygienic travel."
    },
    {
      WhyChooseheading: "Instant Online Booking",
      WhyChoosedescription: "Secure online cab booking navi mumbai to kolhapur with real-time confirmation."
    },
    {
      WhyChooseheading: "Flexible Travel Options",
      WhyChoosedescription: "One way, round trip, and outstation packages available for convenient planning."
    },
    {
      WhyChooseheading: "Customer Satisfaction Focus",
      WhyChoosedescription: "We prioritize punctuality, comfort, and professional service standards."
    }
  ]
}



const faqData = [
    {
        id: 1,
        question: 'How can I book a Navi Mumbai to Kolhapur Cab with Skyline Cabs?',
        answer:
            'You can easily book your Navi Mumbai to Kolhapur Cab through our website or mobile app. Enter Navi Mumbai as your pickup location and Kolhapur as your drop destination, select your preferred vehicle, and confirm instantly. After booking, you receive driver details and ride confirmation for a smooth and stress-free journey.',
    },
    {
        id: 2,
        question: 'Is Navi Mumbai to Kolhapur Cab service available 24/7?',
        answer:
            'Yes, Skyline Cabs provides 24/7 Navi Mumbai to Kolhapur Cab service. Whether you prefer early morning departures or overnight travel, our professional drivers and well-maintained vehicles are available round the clock for your convenience.',
    },
    {
        id: 3,
        question: 'What vehicle options are available for Navi Mumbai to Kolhapur Cab?',
        answer:
            'We offer multiple vehicle options including economical Sedans, spacious SUVs like Ertiga, premium Innova Crysta, and luxury cars. Our Navi Mumbai to Kolhapur Cab service is designed to accommodate solo travelers, families, and group travel comfortably.',
    },
    {
        id: 4,
        question: 'How much is the Navi Mumbai to Kolhapur Cab fare?',
        answer:
            'The Navi Mumbai to Kolhapur Cab fare depends on the vehicle type and trip option (one-way or round-trip). Skyline Cabs offers competitive and transparent pricing that includes toll charges, driver allowance, and applicable taxes with no hidden fees.',
    },
    {
        id: 5,
        question: 'Is one-way Navi Mumbai to Kolhapur Cab available?',
        answer:
            'Yes, Skyline Cabs provides affordable one-way Navi Mumbai to Kolhapur Cab service. You only pay for the distance traveled without unnecessary return charges, making it budget-friendly for one-direction trips.',
    },
    {
        id: 6,
        question: 'How long does it take to travel from Navi Mumbai to Kolhapur by cab?',
        answer:
            'The journey from Navi Mumbai to Kolhapur usually takes around 7 to 9 hours depending on traffic and road conditions. Skyline Cabs ensures a comfortable highway travel experience with experienced drivers and smooth vehicles.',
    },
    {
        id: 7,
        question: 'Are online payments available for Navi Mumbai to Kolhapur Cab?',
        answer:
            'Yes, Skyline Cabs supports secure online payments via UPI, credit cards, debit cards, and net banking. Instant booking confirmation is sent once the payment is completed successfully.',
    },
    {
        id: 8,
        question: 'Can I schedule my Navi Mumbai to Kolhapur Cab in advance?',
        answer:
            'Absolutely. You can pre-book your Navi Mumbai to Kolhapur Cab for weekends, holidays, or planned trips. Advance booking ensures vehicle availability and better travel planning.',
    },
    {
        id: 9,
        question: 'Is Navi Mumbai to Kolhapur Cab suitable for family trips?',
        answer:
            'Yes, our spacious and comfortable vehicles make Navi Mumbai to Kolhapur Cab ideal for family travel. With ample luggage space and experienced drivers, we ensure a safe and relaxed journey for all passengers.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Navi Mumbai to Kolhapur Cab?',
        answer:
            'Skyline Cabs is trusted for Navi Mumbai to Kolhapur Cab service because of our transparent pricing, professional chauffeurs, sanitized vehicles, punctual pickups, and 24x7 customer support. We focus on delivering safe, reliable, and comfortable long-distance travel experiences every time.',
    },
];

const someReviews = [
    {
        name: "Mr. Amit Jadhav",
        rating: 5,
        review: "Booked a Navi Mumbai to Kolhapur Cab with Skyline Cabs for a family trip. The driver was professional, the car was very comfortable, and the journey was smooth throughout. Highly recommended service!"
    },
    {
        name: "Mrs. Sneha Kulkarni",
        rating: 4,
        review: "Very reasonable Navi Mumbai to Kolhapur Cab fare and excellent service quality. Clean vehicle, punctual pickup, and safe driving. Skyline Cabs made our trip comfortable and stress-free."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Kolhapur Cab",
  "image": "https://skylinecabs.com/assets/images/navi-mumbai-to-kolhapur-cab.jpg",
  "description": "Book Navi Mumbai to Kolhapur Cab with Skyline Cabs for safe, comfortable and reliable travel. One way and round trip taxi service available with sedan, SUV and Innova cars driven by professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3999",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/navi-mumbai-to-kolhapur-cab"
  }
};




    return (
        <div>

<Helmet>
  <title>Navi Mumbai to Kolhapur Cab | One Way & Round Trip Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai to Kolhapur Cab with Skyline Cabs for reliable one way and round trip taxi service. Affordable fares with professional drivers and comfortable cars available 24x7." 
  />
  <meta 
    name="keywords" 
    content="mumbai to kolhapur cab, mumbai airport to kolhapur cab, mumbai kolhapur cab service, mumbai to kolhapur car rental, navi mumbai to kolhapur cab, navi mumbai to kolhapur taxi, navi mumbai to kolhapur cab service, taxi from navi mumbai to kolhapur, cab from navi mumbai to kolhapur, book cab navi mumbai to kolhapur, online cab booking navi mumbai to kolhapur, best cab navi mumbai to kolhapur, cheapest cab navi mumbai to kolhapur, reliable taxi navi mumbai to kolhapur, one way cab navi mumbai to kolhapur, round trip cab navi mumbai to kolhapur, Skyline Cabs Navi Mumbai to Kolhapur" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/126.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Navimumbaitokolhapurcab;